import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from '../Components/Redux/authSlice';
import { RootState } from '../Components/Redux/store';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ExpenseList.css';

const ExpenseList: React.FC = () => {
  const [expenses, setExpenses] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const dispatch = useDispatch();

  const auth = useSelector((state: RootState) => state.auth.value);

  const getCookie = (name: string) => {
    const cookieName = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return '';
  };

  const fetchData = useCallback(async () => {
    try {
      const token = getCookie('token');
      if (!token) {
        dispatch(setAuth(false));
        return;
      }
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const { data } = await axios.get('/users/user', {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log('User Info:', data);
      dispatch(setAuth(true));
    } catch (e) {
      console.error('Error fetching user data:', e);
      dispatch(setAuth(false));
    }
  }, [dispatch]);

  const fetchExpenses = async (page: number = 1) => {
    try {
      const response = await axios.get(`/fees/expenses/?page=${page}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      setExpenses(response.data.results);
      setTotalPages(response.data.total_pages);
      setCurrentPage(page);
      console.log('Expenses:', response.data);
    } catch (error) {
      console.error('Error fetching expenses:', error);
    }
  };

  const handleDeleteExpense = async (id: number) => {
    if (window.confirm('Ma hubtaa inaad rabto inaad tirtirto kharashkan?')) {
      try {
        const token = getCookie('token');
        if (!token) {
          dispatch(setAuth(false));
          return;
        }
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        await axios.delete(`/fees/expenses/${id}/`);
        setExpenses(expenses.filter(expense => expense.id !== id));
        alert('Si guul leh ayaa loo tirtiray kharashka.');
      } catch (error) {
        console.error('Error deleting expense:', error);
        alert('Khalad ayaa dhacay markii la tirtirayay kharashka. Fadlan isku day markale.');
      }
    }
  };

  const handlePageChange = (page: number) => {
    fetchExpenses(page);
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (auth) {
      fetchExpenses();
    }
  }, [auth]);

  return (
    <div className="expense-container">
      {/* Hero Header */}
      <div className="expense-hero">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="icon">💸</span> Maamulka Kharashyada
          </h1>
          <p className="hero-subtitle">La soco oo maamul dhammaan kharashyada iskuulka</p>
        </div>
      </div>

      {auth ? (
        <>
          {/* Action Bar */}
          <div className="action-bar">
            <h2 className="mb-0">Liiska Kharashyada</h2>
            <Link to="/expenses" className="add-expense-btn">
              <i className="fas fa-plus"></i> Ku Dar Kharash Cusub
            </Link>
          </div>
          <div className="table-responsive">
            <table className="table table-hover table-bordered table-sm">
              <thead className="thead-dark bg-gray-200">
                <tr>
                  <th scope="col" className="py-3 text-sm md:text-base">#</th>
                  <th scope="col" className="py-3 text-sm md:text-base">Nooca Kharashka</th>
                  <th scope="col" className="py-3 text-sm md:text-base">Qiimaha</th>
                  <th scope="col" className="py-3 text-sm md:text-base">Taariikhda</th>
                  <th scope="col" className="py-3 text-sm md:text-base">Ficilada</th>
                </tr>
              </thead>
              <tbody>
                {expenses.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center py-3 text-sm md:text-base">
                      Ma jirto xog la heli karo
                    </td>
                  </tr>
                ) : (
                  expenses.map((expense, index) => (
                    <tr key={expense.id} className="hover:bg-gray-50 transition-colors duration-150">
                      <th scope="row" className="py-3 text-sm md:text-base">
                        {(currentPage - 1) * 15 + index + 1}
                      </th>
                      <td className="py-3 text-sm md:text-base">{expense.Expenses_type}</td>
                      <td className="py-3 text-sm md:text-base">ksh {expense.Cost}</td>
                      <td className="py-3 text-sm md:text-base">{expense.date_paid_expenses}</td>
                      <td className="py-3 text-sm md:text-base">
                        <button
                          className="btn btn-sm btn-danger bg-red-600 hover:bg-red-700 transition-colors duration-200 w-full md:w-auto"
                          onClick={() => handleDeleteExpense(expense.id)}
                        >
                          Tirtir
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-items-center flex-column md:flex-row gap-2 mt-4">
            <button
              className="btn btn-sm btn-primary bg-blue-600 hover:bg-blue-700 transition-colors duration-200 w-full md:w-auto"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Hore
            </button>
            <span className="text-sm md:text-base">Bogga {currentPage} ee {totalPages}</span>
            <button
              className="btn btn-sm btn-primary bg-blue-600 hover:bg-blue-700 transition-colors duration-200 w-full md:w-auto"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Xiga
            </button>
          </div>
        </>
      ) : (
        <div className="text-center mt-5">
          <h3 className="text-gray-600 text-lg md:text-xl">
            Ma aadan xaqiijin ama awood uma lihid inaad aragto boggan
          </h3>
          <Link to="/login" className="btn btn-primary mt-3">
            Aad Login
          </Link>
        </div>
      )}
    </div>
  );
};

export default ExpenseList;